<template>
  <div class="w-screen min-h-screen flex justify-center items-center flex-col">
    <!-- <div class="grid grid-cols-3 mb-2">
      <div></div>
      <div class="mx-auto flex justify-center items-center gap-3 mb-4">
        <img src="@/assets/images/logo_icon.svg" class="w-11"/>
        <span class="text-xl font-medium">Sycamore</span>
      </div>
      <div></div>
    </div> -->

    <LoadingLoanForm v-if="tab == -1" />
    
    <TokenInvalid v-else-if="tab == -2"/>
    
    <div v-else class="max-w-full sm:max-w-md mx-auto w-full max-sm:h-full relative">
      <div class="inset-y-0 right-0 flex flex-col justify-center items-center _h-full md:_h-5/6 md:my-3 min-h-screen w-full bg-white sm:rounded-lg">
        
        <div v-if="tab == 0" class="s-height md:min-h-5/6 w-full">
            <div class="grid grid-cols-3 mb-2 px-5 pt-5">
              <div class="my-auto">
                <div>
                </div>
              </div>
              <div class="mx-auto flex justify-center items-center gap-3 mb-4">
                <img src="@/assets/images/sycamore_logo.svg" width="100"/>
              </div>
              <div></div>
            </div>
    
            <div class="card-content">
              <form action="POST" accept-charset="UTF-8" class="flex flex-col gap-6">
                <div v-for="(key, document) in documents" :key="key">
                  <div class="text-center">
                    <p class="text-md font-semibold text-gray-900 pb-1">Upload {{ document.replaceAll('_', ' ') }}</p>
                  </div>
    
                  <div class="w-full mt-1">
                    <b-field>
                      <b-upload @input="handleFileChange($event, document)" accept=".jpg, .jpeg, .png, .pdf"
                                class="upload-container" :class="documents[document] !== null? 'uploaded' : ''" expanded>
                        <a class="upload-button w-full h-full flex justify-center items-center">
                                        <span v-if="!documents[document]"
                                              class="dds text-gray-600 flex justify-center items-center">
                                            <i class="ri-2x ri-upload-cloud-2-line font-light"></i>
                                            <span class="pl-2 font-medium">Click to upload</span>
                                        </span>
                          <span v-else class="font-medium"
                                style="color:#00a746">{{ documents[document].name }}</span>
                        </a>
                      </b-upload>
                    </b-field>
                  </div>
                </div>
    
                <div class="flex">
                  <div class="buttons ml-auto">
                    <b-button
                        native-type="button"
                        @click="submit"
                        :loading="isLoading"
                        class="button is-primary text-sm md:w-48"
                        :disabled="isLoading ? true : false"
                    >
                      Submit Documents
                    </b-button>
                  </div>
                </div>
              </form>
            </div>
        </div>
        
        <div v-else-if="tab == 1" class="s-height w-full">
          <LoanFormSubmitSuccess/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {verifyToken} from "@/api/auth";
import {submitGuarantorDocuments} from "@/api/loan";
import OTPBoxes from '@/components/otp/boxes'
import Ripple from '@/components/Ripple';
import ReviewForm from "@/components/loan/guarantorReviewForm";
import LoanFormSubmitSuccess from "@/components/loan/formSubmitSuccess";
import LoadingLoanForm from "@/components/loan/loading";
import TokenInvalid from "@/components/TokenInvalid.vue";

export default {
  components: {
    OTPBoxes,
    Ripple,
    ReviewForm,
    LoanFormSubmitSuccess,
    LoadingLoanForm,
    TokenInvalid
  },

  data() {
    return {
      tab: -1,
      isLoading: false,
      loanId: null,
      documents: null,
    }
  },

  methods: {
	  handleFileChange(value, key) {
	    const canUpload = this.$dataHandler.onFileChange(value);
	    if (canUpload) {
	      if (key == 'signature') {
	        this.documents.signature = value;
	      } else {
	        this.documents[key] = value;
	      }
	    } else {
		    this.$buefy.notification.open({
		        message: "Please upload a valid file. File must be either (png, jpg, jpeg, pdf)",
		        duration: 7000,
		        progressBar: true,
		        type: 'is-danger',
		        pauseOnHover: true
		    })
	      this.file = null
	    }
	  },
    async submit() {
      try {
        this.isLoading = true;
        const form = new FormData();
        for (let doc in this.documents) {
          form.append(doc, this.documents[doc]);
          console.log(doc)
          if (!this.documents[doc])
          	throw new Error(`Please upload your ${doc.replaceAll("_", " ")}`);
        }

        form.append("loan_id", this.loanId);
        await submitGuarantorDocuments(form);
        this.proceed();
      } catch (e) {
        this.$buefy.notification.open({
            message: e.response?.data?.message ?? e.message,
            duration: 7000,
            progressBar: true,
            type: 'is-danger',
            pauseOnHover: true
        })
      } finally {
        this.isLoading = false;
      }
    },
    proceed() {
      this.tab = this.tab + 1;
    },
    async fetchUserDetails() {
      const {token} = this.$route.query;

      this.isLoading = true;
      try {
        let response = await verifyToken({userToken: token});

        this.loanId = response.data.data.loan_id;
        this.documents = response.data.data.document_to_upload
            ?.split(",")
            .reduce((acc, curr) => ({
              ...acc,
              [curr]: null
            }), {}) ?? {},

            this.tab = 0;
      } catch (e) {
        this.tab = -2;
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.fetchUserDetails();
  }
}
</script>

<style lang="scss" scoped>
.upload-container {
  height: 150px;
  width: 100%;
  border-radius: 7px;
  padding: 8px;
  aspect-ratio: 1;
  position: relative;
  clip-path: inset(0 round 30px 0 30px 0);
}

.upload-container::before, .uploaded::before {
  content: '';
  position: absolute;
  right: -7px;
  top: -7px;
  left: -7px;
  bottom: -7px;
  border: 8px dashed #bcbaba;
  border-radius: 37px 0 37px 0;
  box-sizing: border-box;
  transition: background .2s ease-in-out, border .2s ease-in-out;
}

.upload-container:hover::before, .uploaded::before {
  border: 8px dashed #00bf4e;
}

.upload-button {
  position: relative;
  z-index: 2;
  background-color: #55555511;
  transition: background .2s ease-in-out, border .2s ease-in-out;
  border-radius: 28px 0 28px 0;
}

.upload-button:hover, .uploaded .upload-button {
  background-color: #d6eee1;
}

.upload-button:hover .dds {
  color: #00a746;
}

.s-height {
  // height: 100vh;
  font-family: 'Poppins';
}

.s-width {
  width: 100vw;
}

label {
  font-size: 13px;
  font-weight: 500;
  display: block;
  padding-bottom: 5px;
  color: #484848;
}

.button {
  height: 45px !important;
  border-width: 0.5px !important;
  border-radius: 8px !important;
  font-weight: 500 !important;
}

.input {
  height: 40px !important;
  font-size: 12px !important;
  color: #001800 !important;
  padding-left: 19px 1 !important;
  box-shadow: none !important
}

.double-box-shadow {
  box-shadow: rgba(224, 224, 224, 1) 3px 3px, rgba(245, 245, 245, 1) 7px 7px;
}
</style>